import script from "./AdminPaperUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPaperUpload.vue?vue&type=script&setup=true&lang=js"

import "./AdminPaperUpload.vue?vue&type=style&index=0&id=ef1bb672&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef1bb672"]])

export default __exports__